import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Request from "common/Request";
import { parseNames } from "../api";
import ColumnsGrid from "common/layouts/ColumnsGrid";
import AddressInput from "./AddressInput";
import SwitchInput from "common/SwitchInput";
import SelectInputWithIcon from "common/SelectInputWithIcon";
import SelectAutocomplete from "common/SelectAutocomplete";

const doesNothing = () => {};

const _linesOptions = [
  { label: "100", value: 100 },
  { label: "1000", value: 1000 },
  { label: "10000", value: 10000 },
  { label: "100000", value: 100000 },
  { label: "1000000", value: 1000000 },
];
const _directionOptions = [
  { label: "Downlink", value: "downlink" },
  { label: "Uplink", value: "uplink" },
];
const nameAsOption = (name) => ({ label: name, value: name });
const requestRatePolicies = () =>
  ifCl.run("show policy rate").then((response) => parseNames(response, "NAME"));

const requestSubscriberGroups = () =>
  ifCl.run("show api subscriber-group").then((response) => parseNames(response, "SUBSCRIBER-GROUP"));

const ControlsAndResultsLayout = styled.div`
  flex: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .input-group {
    margin-bottom: 0;
  }

`;

const allPolicies = { label: "All rate policies", value: "all" };
const allSubscriberGroups = {label: 'All subscriber-groups', value: 'all'};

const FilteringControls = ({
  defaults = {},
  subnet = undefined,
  policy = undefined,
  subscriberGroup = undefined,
  direction = undefined,
  settings,
  setSettings
}) => {
  const [ratePoliciesRequest, setRatePoliciesRequest] = useState(null);
  const [subscriberGroupsRequest, setSubscriberGroupsRequest] = useState(null);

  useEffect(() => {
    setRatePoliciesRequest(requestRatePolicies());
    setSubscriberGroupsRequest(requestSubscriberGroups());
  }, [])

  const onChange = (event) => {
    const { target } = event;
    const value =
      target.type !== "checkbox"
        ? target.value
        : target.value === "on" && target.checked === true;
    setSettings((settings) => ({
      ...settings,
      [target.name]: value,
    }));
  };
  return (
    <ControlsAndResultsLayout>
      <ColumnsGrid
        columns={4}
        minWidth="15rem"
        gap="3rem"
        rowGap="10px"
        className="subscribers-report-controls"
      >
        <SelectInputWithIcon
          title="Lines"
          name="lines"
          icon="format_line_spacing"
          selected={settings.lines}
          onChange={onChange}
          options={_linesOptions}
        />
        <SelectInputWithIcon
          title="Direction"
          name="direction"
          icon="import_export"
          selected={settings.direction}
          onChange={onChange}
          options={_directionOptions}
        />
        <Request during={ratePoliciesRequest}>
          {({ names }) => (
            <SelectAutocomplete
              title="Policies"
              name="policy"
              icon="folder_open"
              selected={settings.policy}
              onChange={(value) => {
                setSettings({ ...settings, ["policy"]: value });
              }}
              options={[allPolicies, ...names.map(nameAsOption)]}
            />
          )}
        </Request>
        <Request during={subscriberGroupsRequest}>
          {({ names }) => {
            const options = [...names].reduce((acc, value) => {
              if (value !== "all-subscribers") {
                acc.push({ label: value, value });
              }
              return acc;
            }, []);
            return (
              <SelectAutocomplete
                title="Subscriber groups"
                name="subscriberGroup"
                icon="group"
                selected={settings.subscriberGroup}
                onChange={(value) => {
                  setSettings({ ...settings, ["subscriberGroup"]: value });
                }}
                options={[allSubscriberGroups, ...options]}
              />
            );
          }}
        </Request>
        <AddressInput
          value={settings.subnet}
          name="subnet"
          onChange={onChange}
          className="input-group"
        />
      </ColumnsGrid>
    </ControlsAndResultsLayout>
  );
};
export default FilteringControls;
